module.exports = __webpack_public_path__ + "img/truck-3.c8142989.png";